var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 212,
    viewBox: "0 0 186 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_25897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.539 59.211C167.5 58.9674 167.46 58.7317 167.413 58.4882C167.389 58.3624 167.366 58.2289 167.334 58.1032C166.201 52.7996 162.936 48.1639 158.238 45.3432L86.1465 1.9564C80.8116 -1.25715 73.9659 -0.447868 69.5359 3.92067L9.60096 62.951C5.69814 66.7931 3.6051 72.0652 3.74674 77.4866C3.74674 77.6202 3.74674 77.7459 3.76247 77.8795C3.77034 78.123 3.79395 78.3666 3.80969 78.6102C3.81755 78.7359 3.81755 78.8695 3.83329 78.9952L3.86477 79.2859L4.96637 88.5651L85.3281 136.925C90.663 140.139 97.5087 139.33 101.939 134.961L168.743 69.1738L167.61 59.6117C167.594 59.4782 167.563 59.3603 167.547 59.2267L167.539 59.211Z",
    fill: "url(#paint0_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.539 59.211C167.5 58.9674 167.46 58.7317 167.413 58.4882C167.389 58.3624 167.366 58.2289 167.334 58.1032C166.201 52.7996 162.936 48.1639 158.238 45.3432L86.1465 1.9564C80.8116 -1.25715 73.9659 -0.447868 69.5359 3.92067L9.60096 62.951C5.69814 66.7931 3.6051 72.0652 3.74674 77.4866C3.74674 77.6202 3.74674 77.7459 3.76247 77.8795C3.77034 78.123 3.79395 78.3666 3.80969 78.6102C3.81755 78.7359 3.81755 78.8695 3.83329 78.9952L3.86477 79.2859L4.96637 88.5651L85.3281 136.925C90.663 140.139 97.5087 139.33 101.939 134.961L168.743 69.1738L167.61 59.6117C167.594 59.4782 167.563 59.3603 167.547 59.2267L167.539 59.211Z",
    fill: "url(#paint1_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.469 6.95271L4.48999 24.4678L19.5076 150.977L167.487 133.462L152.469 6.95271Z",
    fill: "url(#paint2_radial_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75451 77.8714C3.75451 77.7378 3.74664 77.6121 3.73877 77.4785C3.73877 77.9657 3.77024 78.4528 3.82532 78.9399C3.81746 78.8221 3.80959 78.7121 3.80172 78.5942C3.77811 78.3507 3.76238 78.1071 3.75451 77.8635V77.8714Z",
    fill: "url(#paint3_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.499 58.983C167.452 58.6845 167.405 58.3937 167.334 58.103C167.366 58.2287 167.389 58.3545 167.413 58.488C167.444 58.653 167.468 58.818 167.499 58.983Z",
    fill: "url(#paint4_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.939 134.945C97.5008 139.314 90.663 140.123 85.3281 136.909L4.96631 88.5569L14.9594 172.675C15.8328 180.029 22.5054 185.278 29.8703 184.406L166.98 168.165C174.345 167.293 179.601 160.622 178.728 153.276L168.735 69.1577L101.931 134.945H101.939Z",
    fill: "url(#paint5_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4306 88.5257C91.0957 85.3122 84.2501 86.1215 79.8201 90.49L13.0159 156.277L14.9594 172.667C15.8328 180.022 22.5054 185.27 29.8704 184.398L166.98 168.157C174.345 167.285 179.601 160.622 178.728 153.268L176.785 136.878L96.4228 88.5179L96.4306 88.5257Z",
    fill: "url(#paint6_linear_366_25897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.108 40.6371L97.965 32.6621L76.1612 60.2955L65.2947 51.747L57.3081 61.8748L78.2543 78.3589L78.3015 78.3039L78.3487 78.3432L108.108 40.6371Z",
    fill: "#F6C315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9999 212.008C144.344 212.008 185.967 208.761 185.967 204.756C185.967 200.751 144.344 197.504 92.9999 197.504C41.6556 197.504 0.0327148 200.751 0.0327148 204.756C0.0327148 208.761 41.6556 212.008 92.9999 212.008Z",
    fill: "#E6E7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_25897",
    x1: 194.881,
    y1: 126.958,
    x2: 74.5778,
    y2: 63.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_366_25897",
    x1: 194.881,
    y1: 126.958,
    x2: 74.5778,
    y2: 63.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_366_25897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.7183 10.891) scale(132.05 131.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_366_25897",
    x1: 3.97463,
    y1: 77.8864,
    x2: 3.59952,
    y2: 78.5247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_366_25897",
    x1: 167.525,
    y1: 58.378,
    x2: 167.313,
    y2: 58.7278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_366_25897",
    x1: 119.501,
    y1: 77.1486,
    x2: 65.4631,
    y2: 168.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_366_25897",
    x1: 116.034,
    y1: 202.064,
    x2: 90.6735,
    y2: 143.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C315"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_25897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.934,
    height: 212,
    fill: "white",
    transform: "translate(0.0327148)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterSuccess);
export default __webpack_public_path__ + "static/media/letter-success.fc817602769fe4a44320a0b47bd9c6a3.svg";
export { ForwardRef as ReactComponent };